import React, { useEffect, useState } from "react";
import { ShieldCheck, X } from "lucide-react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// Dismissible "Verify now" nudge on the Dashboard: encourages licensed members to
// complete KYC early so their first cash-out or prize claim is instant.
export const KycPrompt = () => {
  const { user } = useAuth();
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    let dismissed = null;
    try { dismissed = localStorage.getItem("tr_kyc_prompt_dismissed"); } catch (e) { /* ignore */ }
    if (!user?.has_license || dismissed) return;
    api.get("/kyc/status").then((r) => { if (!r.data.kyc_verified) setShow(true); }).catch(() => {});
  }, [user]);

  const verify = async () => {
    setBusy(true);
    try {
      const { data: r } = await api.post("/kyc/session", { origin_url: window.location.origin });
      if (r.already_verified) { setShow(false); setBusy(false); return; }
      window.location.href = r.url;
    } catch (e) { toast.error(apiError(e.response?.data?.detail?.message || e.response?.data?.detail)); setBusy(false); }
  };

  const dismiss = () => {
    try { localStorage.setItem("tr_kyc_prompt_dismissed", "1"); } catch (e) { /* ignore */ }
    setShow(false);
  };

  if (!show) return null;
  return (
    <div data-testid="kyc-prompt" className="flex items-center gap-3 bg-race-volt/10 border border-race-volt/40 rounded-md px-4 py-3 mb-6">
      <ShieldCheck size={18} className="text-race-volt shrink-0" />
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium text-race-txt">Verify your identity now for instant payouts</p>
        <p className="text-xs text-race-sub">A one-time ID check is required before any winnings, prizes or commissions are released. Do it now so your first cash-out is instant.</p>
      </div>
      <button onClick={verify} disabled={busy} data-testid="kyc-prompt-verify"
        className="text-xs font-semibold bg-race-volt text-race-bg rounded-sm px-3 py-1.5 shrink-0 disabled:opacity-50">
        {busy ? "Opening…" : "Verify now"}
      </button>
      <button onClick={dismiss} data-testid="kyc-prompt-dismiss" className="text-race-sub hover:text-race-txt shrink-0"><X size={16} /></button>
    </div>
  );
};

export default KycPrompt;
